import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "roadmap-for-developing-and-packaging-components"
    }}>{`Roadmap for developing and packaging components`}</h1>
    <p>{`To develop your component, use the following steps:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Learn about `}<a parentName="p" {...{
            "href": "../build/composer-integration.md"
          }}>{`using Composer with your component`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><a parentName="p" {...{
            "href": "../build/index.md"
          }}>{`Build your component`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li"><a parentName="p" {...{
            "href": "../package/component.md"
          }}>{`Package a component`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li"><a parentName="p" {...{
            "href": "../validate/test-component.md"
          }}>{`Validate your component`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Upload the components to the Commerce Marketplace.`}</p>
        <p parentName="li">{`See the `}<a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/marketplace/guides/sellers/"
          }}>{`Commerce Marketplace User Guide`}</a>{` for details.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      